import NamedDto from 'modules/base/dto/NamedDto';
import LabMeasurementReaderFieldEditDto from './LabMeasurementReaderFieldEditDto';

export default class LabMeasurementReaderEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string>} */
		this.location = null;
		/** @type {number} */
		this.labConnection = null;
		/** @type {LabMeasurementReaderFieldEditDto[]} */
		this.fields = null;
		/** @type {number} */
		this.aspect = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _LabMeasurementReaderEditDtoProps
	 * @property {string} location
	 * @property {number} labConnection
	 * @property {LabMeasurementReaderFieldEditDto[]} fields
	 * @property {number} aspect
	 * @property {number} userGroup	
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LabMeasurementReaderEditDtoProps} LabMeasurementReaderEditDtoProps
	 */
	/**
	 *
	 * @param {LabMeasurementReaderEditDtoProps} props
	 * @returns {LabMeasurementReaderEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.location = props?.location;
		this.labConnection = props?.labConnection;
		this.fields = Array.isArray(props?.fields) ? props.fields.map(d => new LabMeasurementReaderFieldEditDto().setup(d)) : [];
		this.aspect = props?.aspect;
		this.userGroup = props?.userGroup;
		return this;
	}
}
